"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = Move;

var _Move = require("@adobe/react-spectrum-workflow/dist/Move");

var _icon = require("@react-spectrum/icon");

var _react = _interopRequireDefault(require("react"));

function Move(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.Icon, props, /*#__PURE__*/_react.default.createElement(_Move.A4uMove, null));
}